export default "__VITE_ASSET__CTx_6ku6__"